import { IconComponentProps } from '../IconTypes';

const CheckmarkSmall = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6284 15.5658C10.3862 15.8119 9.98773 15.8119 9.74554 15.5658L6.62015 12.4408C6.37601 12.1986 6.37601 11.8002 6.62015 11.558C6.8639 11.3119 7.2596 11.3119 7.50374 11.558L10.1869 14.2416L15.9955 8.43262C16.2377 8.18848 16.6362 8.18848 16.8784 8.43262C17.1244 8.67637 17.1244 9.07207 16.8784 9.31621L10.6284 15.5658Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckmarkSmall;
